module.exports = __webpack_public_path__ + "static/media/home-projects-menu.57365ab6.png";